import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-botao-incluir',
  templateUrl: './botao-incluir.component.html',
  styleUrls: ['./botao-incluir.component.scss']
})
export class BotaoIncluirComponent {
  @Input() title: string;

  constructor() {}
}
